import React from 'react';
import { Modal } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import PasswordForm from '../../../PasswordForm';
import styles from './setPasswordModal.module.scss';

interface SetPasswordModalProps {
  open: boolean;
  onClose: () => void;
  userName?: string;
  isSubmitting?: boolean;
  onSubmit: (newPassword: string, onSuccess: () => void) => void;
}

const SetPasswordModal: React.FC<SetPasswordModalProps> = ({ open, onClose, userName, isSubmitting = false, onSubmit }) => {
  const handleSubmit = (newPassword: string) => {
    onSubmit(newPassword, onClose);
  };

  return (
    <Modal
      title="Set Password"
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      mask={false}
      centered
      width={640}
      rootClassName={styles.modal}
      destroyOnClose
    >
      <p className={styles.byLine}>
        If you would like to change the password for <span className={styles.highlightedName}>{userName}, </span>
        please enter and confirm a new password below.
      </p>
      <PasswordForm
        onSubmit={handleSubmit}
        onCancel={onClose}
        submitLabel="SET"
        confirmLabel="CONFIRM NEW PASSWORD"
        passwordPlaceholder="Please enter your new password"
        confirmPlaceholder="Please re-enter your new password"
        cancelIcon={<CaretLeftOutlined />}
        submitIcon={<CaretRightOutlined />}
        isSubmitting={isSubmitting}
        compactButtons
      />
    </Modal>
  );
};

export default SetPasswordModal;
